import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "io-section__content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LazyBackgroundMedia = _resolveComponent("LazyBackgroundMedia")!

  return (_openBlock(), _createElementBlock("section", {
    id: _ctx.anchorId,
    class: _normalizeClass(["io-section", _ctx.sectionClass])
  }, [
    _createVNode(_component_LazyBackgroundMedia, {
      class: _normalizeClass(["io-section__background", _ctx.backgroundClass]),
      mediaSizes: _ctx.mediaSizes
    }, null, 8, ["class", "mediaSizes"]),
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 10, _hoisted_1))
}